import {
    useState,
    useCallback,
    useRef,
    useEffect
} from 'react'

import { useSearchParams } from '@remix-run/react'

import useHasMatch from '~/hooks/useHasMatch'

import Header from '~/components/Header'
import HiddenFormInput from '~/components/HiddenFormInput'
import FamilySearchPage from '~/pages/search/FamilySearchPage'

import * as Styled from './style'
import type * as Types from './types'
import type { SearchRef } from '~/components/Search/types'

const DEFAULT_PAGE = 1
const DEFAULT_HITS_PER_PAGE = 24

const FamilyStartPage: Types.FamilyStartPageComponent = () => {
    const mounted = useRef(false)
    const headerRef = useRef<SearchRef>(null)

    const [searchParams] = useSearchParams()

    const sortParam = searchParams.get('sort') || 'desc'

    const [page, setPage] = useState(DEFAULT_PAGE)
    const [hitsPerPage] = useState(DEFAULT_HITS_PER_PAGE)
    const [sorting, setSorting] = useState(sortParam)

    const isMatchingFiraRoute = useHasMatch('routes/fira/index')
    const isMatchingMinnasRoute = useHasMatch('routes/minnas/index')

    useEffect(() => {
        if (mounted.current) {
            headerRef.current?.submit()
        }

        mounted.current = true
    }, [
        page,
        sorting
    ])

    const handleOnSearchChange = useCallback(() => {
        setPage(DEFAULT_PAGE)
    }, [])

    const handleOnPaginationChange = useCallback((value: number) => {
        setPage(value)
    }, [])

    const handleOnSortingChange = useCallback((value: string) => {
        setSorting(value)
    }, [])

    const famlyType = isMatchingMinnasRoute ? (
        'minnas'
    ) : (
        isMatchingFiraRoute ? (
            'fira'
        ) : (
            'UNKNOWN'
        )
    )

    return (
        <Styled.Form
            method={'get'}
            action={`/${famlyType}/`}
        >
            <HiddenFormInput
                name={'page'}
                value={`${page}`}
            />

            <HiddenFormInput
                name={'hitsPerPage'}
                value={`${hitsPerPage}`}
            />

            <HiddenFormInput
                name={'sort'}
                value={sorting}
            />

            <Styled.Wrapper>
                <Header
                    ref={headerRef}
                    onSearchChange={handleOnSearchChange}
                />
                
                <FamilySearchPage
                    page={page}
                    sorting={sortParam}
                    onSortingChange={handleOnSortingChange}
                    onPaginationChange={handleOnPaginationChange}
                />
            </Styled.Wrapper>
        </Styled.Form>
    )
}

export default FamilyStartPage